import dexon from '@/assets/images/networks/dexon.svg';

export default {
  name: 'DXN',
  name_long: 'DEXON Network',
  homePage: 'https://dexon.org/',
  blockExplorerTX: 'https://dexonscan.app/transaction/[[txHash]]',
  blockExplorerAddr: 'https://dexonscan.app/address/[[address]]',
  chainID: 237,
  tokens: [],
  contracts: [],
  icon: dexon,
  currencyName: 'DXN'
};
